import { Component, Input, Output, EventEmitter, OnInit, OnChanges, ChangeDetectorRef } from '@angular/core';
import { FileUploadService } from 'src/app/services/file-upload.service';
import { FormBuilderService } from 'src/app/services/form-builder.service';
import { JobServicesService } from 'src/app/services/job-services.service';
import { environment } from 'src/environments/environment';
import { GlobalServicesService } from 'src/app/services/global-services.service';
import { EventServicesService } from 'src/app/services/event-services.service';
import { MessageService } from 'primeng/api';
import { candidateStatus, statusColorMapping } from 'src/app/enum/candidate-status.enum';
import { DomSanitizer } from '@angular/platform-browser';
import { HttpResponse } from '@angular/common/http';
import { DatePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { FieldLookupService } from 'src/app/services/field-lookup.service';

export interface FormModel {
  fieldId?: string,
  fieldOrder: number,
  fieldName: string,
  fieldDescription: string,
  isMandatory: boolean,
  formName: string,
  displaySection: string,
  placeHolder: string,
  fieldType: string,
  answer: Array<any>,
  isValid?: boolean,
  schoolId?: string,
  dependant?: Dependancy,
  fieldDefaultValue?: Array<any>,
  fieldOptions?: Array<FieldOptions>,
  fileProperities?: FieldProperties,
  visible?: boolean,
}

export interface Dependancy {
  dependantOn: string,
  dependantValues: Array<string>
}

export interface FieldOptions {
  label: string,
  value: any
}

export interface FieldProperties {
  fileFormat: Array<string>,
  fileSize: any
}

@Component({
    selector: 'app-candidate-info',
    templateUrl: './candidate-info.component.html',
    styleUrls: ['./candidate-info.component.css'],
    providers: [MessageService, DatePipe],
    standalone: false
})
export class CandidateInfoComponent implements OnInit, OnChanges {

  userInfo: Array<any> = [];
  personalInfo: Array<any> = [];
  educationQualification: Array<any> = [];
  
  eventDetails: Array<any> = [];
  usersAllEvent: Array<any> = [];
  experience: Array<any> = [];
  displayInfo: boolean = true;
  displayResume: boolean = false;
  displayFeedback: boolean = false;
  displayActivity: boolean = false;
  displayInsights: boolean = false;
  userDetails: any;
  registrationFormId: number | null = null;
  documentationFormId: number | null = null; 
  feedbackFormId: number | null = null;
  feedbackDetailsData: Array<any> = [];
  showFeedbackMenu: boolean = false;
  feedbackSubmittedDate: string = "-";
  testDetails: any[] = [];
  showTestMenu: boolean = false;
  showTestDialog: boolean = false;
  testDetailsData: any[] = [];
  registrationForms: Array<{ formId: number, submittedDate: string }> = [];
  documentationForms: Array<{ formId: number, submittedDate: string, stageName: string }> = [];
  feedbackForms: Array<{ formId: number, submittedDate: string, formName: string, stageName: string }> = [];
  groupedFeedbackForms: Array<any> = [];
  selectedFeedbackPanelIndex: number = 0;
  selectedFeedbackGroupIndex: number = -1;
  testDetailsList: Array<any> = [];
  allRegistrationDetails: Array<any> = [];
  allDocumentationDetails: Array<any> = [];
  allFeedbackDetails: Array<any> = [];

  jobId: string = window.localStorage.getItem('selectedJobId') || '';
  eventId: string = '';
  isInEvent: boolean = this.jobId === this.eventId;
  signedProfileUrl: string = '';

  candidateStatus: any = {}
  statusColor: Array<any> = [];

  stages: Array<any> = [];
  allUsers: Array<any> = [];
  pdfSrc: string |null = null;
  resumeFileType: string = 'pdf';
  feedbackDetails: any = [];
  stageNameIdmapping: any = [];
  showDialog: boolean = false;
  paramItems: any;
  isLoadingFeedback: boolean = true;
  isLoading: boolean = false;
  isLoadingResume: boolean = false;
  allFormDetails: any = [];
  isLoadingDetails: boolean = false
  showRegistrationDialog: boolean = false;
  showDocumentationDialog: boolean = false; 
  showFeedbackDialog: boolean = false; 
  editAllDetailDialog: boolean = false;
  displayDetails: boolean = false;
  registrationDetails: Array<{ label: string; value: string }> = [];
  detailsGrouped: Array<any> = [];
  documentationDetails: Array<any> = [];
  showRegistrationMenu: boolean = false;
  showDocumentationMenu: boolean = false;
  registrationSubmittedDate: string = "-";
  documentationSubmittedDate: string = "-";
  allFormTemplate: any = [];
  userRole: string = '';
  userPrivileges: Set<string> = new Set();
  formLists: any = [];
  formDetails: any = [];
  eventCategory: string = '';
  candidateActivity: any = [];
  timelyActivity: any = [];
  duplicateData: any = {};
  roleScores: any[] = [];
  companyMetadata: any = {};

  jobName: string = window.localStorage.getItem('selectedJobName') || '';
  @Input() selectedUser: any = {};
  @Input() numberOfStages: number = 0;
  @Input() disableFeedback: any;
  @Input() disableActivity: any;
  @Input() disableStage: any;
  @Input() showBackButton: boolean = false;
  @Output() backClicked = new EventEmitter<void>();

  templateModels: Array<FormModel> = [];
  templateCollections: Array<Array<FormModel>> = [];
  invalidField: any;
  ansChange: boolean = false;
  inEditMode: boolean = false;
  clicked: boolean = false;
  isFormValid: boolean = false;
  submitBtnLoading: boolean = false;
  selectedForm: string = '';
  belowAge: boolean = false;
  dateFormat: any;
  timeFormat: any;
  combainFormat: any;
  documentLoading: boolean = false;
  pgExpanded: boolean = false;
  ugExpanded: boolean = false;
  diplomaExpanded: boolean = false;
  
  hasPGDetails: boolean = false;
  hasUGDetails: boolean = false;
  hasDiplomaDetails: boolean = false;
  pgEducationFields: any[] = [];
  ugEducationFields: any[] = [];
  diplomaEducationFields: any[] = [];

  // Expandable sections state
  expandedSection: string | null = null;
  
  // Filter state
  activeFilter: string = 'all';

  constructor(
      private jobService: JobServicesService, 
      private globalService: GlobalServicesService,
      private messageService: MessageService,
      private cdr: ChangeDetectorRef,
      public  sanitizer: DomSanitizer,
      private datePipe: DatePipe,
      private activatedRoute: ActivatedRoute,
      private formBuilderService: FormBuilderService,
      private fieldLookupService: FieldLookupService,
    ) { }

  ngOnInit() {
    this.globalService.privilegeDetailsSubject.subscribe((privileges) => {
      this.userPrivileges = privileges;
    });
    this.dateFormat = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details') || '{}').company_settings?.date_format : '';

    this.timeFormat = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details') || '{}').company_settings?.time_format : '';

    this.combainFormat = this.timeFormat == 'hh:mm' ? this.dateFormat + '  ' + this.timeFormat + ' a' : this.dateFormat + '  ' + this.timeFormat;
    this.candidateStatus = candidateStatus;


    this.userDetails = localStorage.getItem('userDetails')
      ? JSON.parse(localStorage.getItem('userDetails') || '')
      : '';
    this.eventCategory = localStorage.getItem('eventCategory') || 'technical';
    this.selectedForm = this.eventCategory == 'nonTechnical' ? 'Registration Form Non-Technical' : 'Registration Form';

    this.userRole = this.globalService.privilegeRoles;
    this.loadCompanyMetadata();
  }
  ngOnChanges(): void {
    if (!this.selectedUser) {
      return;
    }
    this.registrationForms = [];
    this.documentationForms = [];
    this.feedbackForms = [];
    this.groupedFeedbackForms = [];
    this.testDetailsList = [];
    this.allRegistrationDetails = [];
    this.allDocumentationDetails = [];
    this.allFeedbackDetails = [];
    this.feedbackDetailsData = [];
    this.registrationDetails = [];
    this.documentationDetails = [];
    this.selectedFeedbackPanelIndex = 0;
    this.selectedFeedbackGroupIndex = -1;
    this.isLoadingFeedback = false;
    if (this.selectedUser?.selectedEventId) {
      const newEventId = this.selectedUser.selectedEventId;
      if (newEventId !== this.eventId) {
        this.eventId = newEventId;
      }
      this.isInEvent = this.jobId === this.eventId;
      this.fetchCandidateInfo();
    } else {
      this.activatedRoute.params.subscribe(params => {
        const newEventId = params['eventId'];
        if (newEventId !== this.eventId) {
          this.eventId = newEventId;
        }
        this.isInEvent = this.jobId === this.eventId;
        this.fetchCandidateInfo();
      });
    }
    if (this.selectedUser?.openTab === 'insights') {
      setTimeout(() => {
        this.showInsights();
        delete this.selectedUser.openTab;
      }, 100);
    }
    if (this.displayFeedback) {
      this.showFeedback();
    }
  }
  
  setEventDetails(eventDetails: any){
    this.eventDetails = [
      { field: "Event", value: eventDetails?.eventTitle ?? '-' },
      { field: "Current Stage ", value: (eventDetails?.stageName) + (eventDetails?.stageType ? (" (" + eventDetails?.stageType + ") ") : '') },
      { field: "Current Status", value: eventDetails?.jobStatus ?? '-' },
    ]
  }

  showInfo = () => {
    this.displayInfo = true;
    this.displayResume = false;
    this.displayFeedback = false;
    this.displayActivity = false;
    this.displayInsights = false;
    this.displayDetails = false; 
  }
  
  showResume = () => {
    this.displayResume = true;
    this.displayInfo = false;
    this.displayFeedback = false;
    this.displayActivity = false;
    this.displayInsights = false;
    if (!this.pdfSrc) { 
        this.fetchResumeUrl();
    }
    this.displayDetails = false; 
};

showInsights = () => {
  this.displayInsights = true;
  this.displayInfo = false;
  this.displayResume = false;
  this.displayFeedback = false;
  this.displayActivity = false;
  this.displayDetails = false;  
  if (!this.roleScores || this.roleScores.length === 0) {
    if (this.isSkillScoreEnabled()) {
      this.isLoadingDetails = true;
      setTimeout(() => {
        this.isLoadingDetails = false;
        this.cdr.detectChanges();
      }, 500);
    } else {
      this.isLoadingDetails = false;
    }
  } else {
    this.isLoadingDetails = false;
  }
};
showActivity = () => {
  this.displayActivity = true;
  this.displayInfo = false;
  this.displayResume = false;
  this.displayFeedback = false;
  this.displayInsights = false;
  this.getCandidateActvity();
  this.displayDetails = false;
};
showFeedback() {
  this.isLoadingFeedback = true;
  this.displayFeedback = true;
  this.displayActivity = false;
  this.displayInfo = false;
  this.displayResume = false;
  this.displayInsights = false;
  this.displayDetails = false;
  this.registrationForms = [];
  this.documentationForms = [];
  this.feedbackForms = [];
  this.testDetailsList = [];
  this.allRegistrationDetails = [];
  this.allDocumentationDetails = [];
  this.allFeedbackDetails = [];
  this.jobService.getCandidateForms(this.eventId, this.selectedUser.id).subscribe(
    (response: any) => {
      const data = response.body;
      if (data?.registration_form?.length > 0) {
        this.registrationForms = this.removeDuplicateForms(data.registration_form.map((form: any) => ({
          formId: form.form_id,
          submittedDate: form.submitted_date || "-"
        })));
        this.registrationFormId = this.registrationForms[0].formId;
        this.registrationSubmittedDate = this.registrationForms[0].submittedDate;
        this.registrationForms.forEach((form, index) => {
          this.fetchCandidateDetails('registration', form.formId, index);
        });
      }
      if (data?.documentation_form?.length > 0) {
        this.documentationForms = this.removeDuplicateForms(data.documentation_form.map((form: any) => ({
          formId: form.form_id,
          submittedDate: form.submitted_date || "-",
          stageName: form.stage_name || "Documentation"
        })));
        this.documentationFormId = this.documentationForms[0].formId;
        this.documentationSubmittedDate = this.documentationForms[0].submittedDate;
      }
      this.jobService.getCandidateFeedback(this.eventId, this.selectedUser.id).subscribe(
        (res: any) => {
          const feedbackList = res?.body?.feedback_details ?? res?.feedback_details ?? [];
          const testList = res?.body?.test_details ?? res?.test_details ?? [];
          if (feedbackList.length > 0) {
            this.feedbackForms = this.removeDuplicateForms(feedbackList.map((feedback: any) => ({
              formId: feedback.form_id,
              submittedDate: feedback.submitted_date || "-",
              formName: feedback.form_name,
              stageName: feedback.stage_name,
              stageUuid: feedback.stage_uuid,
              submittedBy: feedback.submitted_by_name,
              interviewUuid: feedback.interview_uuid,
              submittedById: feedback.submitted_by_id
            })));
            this.feedbackFormId = this.feedbackForms[0].formId;
            this.feedbackSubmittedDate = this.feedbackForms[0].submittedDate;
            this.groupFeedbackByStage();
          }
          
          this.testDetailsList = testList.map((test: any) => ({
            ...test,
            submittedDate: test.scores?.[0]?.submit_time || "-"
          }));
          this.testDetails = this.testDetailsList;

          this.isLoadingFeedback = false;
        },
        () => {
          this.isLoadingFeedback = false;
        }
      );
    },
    () => {
      this.isLoadingFeedback = false;
    }
  );
}
formatDate(date: string): string {
  return this.datePipe.transform(date, this.combainFormat) || '-';
}

getCandidateActvity = async () => {
  this.candidateActivity = [];
  this.timelyActivity = [];
  this.isLoading = true;

  try {
    const response = await this.jobService.getCandidateActivity(this.eventId, this.selectedUser.id).toPromise();
    // When using observe: 'response', data is in response.body
    const activityData = response?.body?.data ?? response?.body ?? response?.data ?? response;

    if (Array.isArray(activityData) && activityData.length > 0) {
      const dateMap: Record<string, any[]> = {};
      this.candidateActivity = activityData.map((activity: any) => {
        const actionText = ['Status Change', 'Move Stage'].includes(activity.action)
          ? activity.action
          : activity.action || 'Unknown Action';

        const oldStage = activity.old_value || '-';
        const newStage = activity.new_value || '-';
        const movedOn = activity.created_at ?? new Date().toISOString();
        const movedDate = activity.created_at?.split('T')[0] ?? '-';

        const formatted = {
          action: actionText,
          remarks: activity.remarks?.trim() || '-',
          createdBy: activity.created_by ?? 'System',
          movedOn,
          movedDate,
          oldStage,
          newStage
        };

        if (!dateMap[movedDate]) dateMap[movedDate] = [];
        dateMap[movedDate].push(formatted);

        return formatted;
      });

      this.timelyActivity = Object.values(dateMap)
        .sort((a, b) => +new Date(b[0].movedOn) - +new Date(a[0].movedOn))
        .map(group => group.sort((a, b) => +new Date(b.movedOn) - +new Date(a.movedOn)));
    } else {
      this.timelyActivity = [];
    }
  } catch (error) {
    this.timelyActivity = [];
  } finally {
    this.isLoading = false;
    this.cdr.detectChanges();
  }
  };
  capitalize(eachField: any) {
    if (eachField.fieldType !== 'multiInputEmail' && eachField.fieldType !== 'email' && eachField.fieldName !== "Candidate ID" &&
    eachField.fieldName !== "University Serial/Registration Number"  && eachField.fieldName !== "Alternate Email Address") {
      return true;
    }
    return false;
  }
  getStatusColor(status: candidateStatus | string): string {
    return statusColorMapping[status as candidateStatus] || '#8B5CF6'; // fallback to purple
  }
  fetchResumeUrl() 
  {
    this.isLoadingResume = true;
    this.pdfSrc = null; 
    this.jobService.getCandidateResume(this.eventId, this.selectedUser.id).subscribe(
        (response: any) => {
            const res = response?.body ?? response;
            if (res && res.resume) {
                const resumeUrl = res.resume.toString().trim();
                this.pdfSrc = resumeUrl;
                this.resumeFileType = this.getFileTypeFromUrl(resumeUrl);
                this.cdr.detectChanges();
            } else {
                this.pdfSrc = null;
                this.resumeFileType = 'pdf';
            }
            this.isLoadingResume = false;
        },
        (error) => {
            this.isLoadingResume = false;
        }
    );
  }

  getFileTypeFromUrl(url: string): string {
    if (!url) return 'pdf';
    const urlLower = url.toLowerCase();
    if (urlLower.includes('.docx')) return 'docx';
    if (urlLower.includes('.doc')) return 'doc';
    if (urlLower.includes('.pdf')) return 'pdf';
    return 'pdf';
  }

  getResumeViewerUrl(url: string): string {
    const fileType = this.getFileTypeFromUrl(url);
    if (fileType === 'docx' || fileType === 'doc') {
      return `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(url)}`;
    }
    return url;
  }

  openResumeInNewTab(): void {
    if (this.pdfSrc) {
      window.open(this.pdfSrc, '_blank');
    }
  }

  fetchCandidateDetails(
    formType: 'registration' | 'documentation' | 'feedback',
    formId?: number,
    index?: number,
    onSuccess?: () => void
  ) {
    if (!this.selectedUser?.id || !this.eventId) return;
  
    this.isLoadingDetails = true;
    
    const targetFormId = formId || (
      formType === 'registration' ? this.registrationFormId :
      formType === 'documentation' ? this.documentationFormId :
      this.feedbackFormId
    );
  
    if (!targetFormId) {
      this.isLoadingDetails = false;
      return;
    }
  
    this.jobService.getCandidateFormDetails(this.eventId, formType, targetFormId).subscribe(
      async (response: any) => {
        if (response?.body?.form_details) {
          this.fieldLookupService.setFormFieldOptions(this.eventId, response.body.form_details);
        }
        const details = response?.body?.form_details
          ? await this.processData(response.body.form_details, response.body.candidate_details)
          : [{ label: "No Data Found", value: "-" }];
  
        if (formType === 'registration') {
          if (index !== undefined) {
            this.allRegistrationDetails[index] = details;
          } else {
            this.registrationDetails = details;
            this.detailsGrouped = this.getGroupedSections(this.registrationDetails)
          }
        } else if (formType === 'documentation') {
          if (index !== undefined) {
            this.allDocumentationDetails[index] = details;
            this.documentationDetails = details;
          } else {
            this.documentationDetails = details;
          }
          this.detailsGrouped = this.getGroupedSections(this.documentationDetails)
        } else if (formType === 'feedback') {
          if (index !== undefined) {
            this.allFeedbackDetails[index] = details;
            this.feedbackDetailsData = details;
          } else {
            this.feedbackDetailsData = details;
          }
        }
  
        this.isLoadingDetails = false;
        this.cdr.detectChanges();
        onSuccess?.();
      },
      (error) => {
        this.isLoadingDetails = false;
        this.cdr.detectChanges();
      }
    );
  }
  
  viewRegistrationByIndex(index: number) {
    const form = this.registrationForms[index];
    if (!form) return;
    
    this.showRegistrationDialog = true;
    
    if (this.allRegistrationDetails[index] && this.allRegistrationDetails[index].length > 0) {
      this.registrationDetails = this.allRegistrationDetails[index];
      this.detailsGrouped = this.getGroupedSections(this.registrationDetails)
      return;
    }
    
    this.fetchCandidateDetails('registration', form.formId, index);
  }
  
  viewDocumentationByIndex(index: number) {
    const form = this.documentationForms[index];
    if (!form) return;
    
    this.showDocumentationDialog = true;
    
    if (this.allDocumentationDetails[index] && this.allDocumentationDetails[index].length > 0) {
      this.documentationDetails = this.allDocumentationDetails[index];
      this.detailsGrouped = this.getGroupedSections(this.documentationDetails)
      return;
    }
    
    this.fetchCandidateDetails('documentation', form.formId, index);
  }
  
  viewFeedbackByIndex(index: number) {
    const form = this.feedbackForms[index];
    if (!form) return;
    
    this.showFeedbackDialog = true;
    this.selectedFeedbackPanelIndex = 0;
    this.selectedFeedbackGroupIndex = -1;

    if (this.allFeedbackDetails[index] && this.allFeedbackDetails[index].length > 0) {
      this.feedbackDetailsData = this.allFeedbackDetails[index];
      return;
    }
    
    this.fetchCandidateDetails('feedback', form.formId, index);
  }

  viewGroupedFeedbackByIndex(groupIndex: number) {
    const group = this.groupedFeedbackForms[groupIndex];
    if (!group) return;

    this.selectedFeedbackPanelIndex = 0;
    this.selectedFeedbackGroupIndex = groupIndex;
    if (group.panelMembers) {
      const firstMember = group.panelMembers[0];
      const feedbackIndex = this.feedbackForms.findIndex((f: any) => f.formId === firstMember.formId);
      if (feedbackIndex >= 0) {
        this.showFeedbackDialog = true;
        if (this.allFeedbackDetails[feedbackIndex] && this.allFeedbackDetails[feedbackIndex].length > 0) {
          this.feedbackDetailsData = this.allFeedbackDetails[feedbackIndex];
        } else {
          this.fetchCandidateDetails('feedback', firstMember.formId, feedbackIndex);
        }
      }
    } else {
      const feedbackIndex = this.feedbackForms.findIndex((f: any) => f.formId === group.formId);
      this.viewFeedbackByIndex(feedbackIndex >= 0 ? feedbackIndex : 0);
    }
  }

  selectFeedbackPanelMember(groupIndex: number, memberIndex: number) {
    const group = this.groupedFeedbackForms[groupIndex];
    if (!group?.panelMembers) return;

    this.selectedFeedbackPanelIndex = memberIndex;
    const member = group.panelMembers[memberIndex];
    const feedbackIndex = this.feedbackForms.findIndex((f: any) => f.formId === member.formId);
    if (feedbackIndex >= 0) {
      if (this.allFeedbackDetails[feedbackIndex] && this.allFeedbackDetails[feedbackIndex].length > 0) {
        this.feedbackDetailsData = this.allFeedbackDetails[feedbackIndex];
      } else {
        this.fetchCandidateDetails('feedback', member.formId, feedbackIndex);
      }
    }
  }

  private groupFeedbackByInterview(forms: any[]): any[] {
    const groups: { [key: string]: any[] } = {};
    const ungrouped: any[] = [];

    forms.forEach(form => {
      if (form.stage_uuid && form.interview_uuid) {
        const key = `${form.stage_uuid}_${form.interview_uuid}`;
        if (!groups[key]) groups[key] = [];
        groups[key].push(form);
      } else {
        ungrouped.push(form);
      }
    });

    const result: any[] = [];
    Object.values(groups).forEach(group => {
      if (group.length > 1) {
        result.push({
          stageName: group[0].stageName,
          submittedDate: group[0].submittedDate,
          panelMembers: group
        });
      } else {
        result.push(group[0]);
      }
    });
    ungrouped.forEach(form => result.push(form));
    return result;
  }
  viewTestDetailsByIndex(index: number) {
    const test = this.testDetailsList[index];
    if (!test) return;
    
    this.testDetailsData = this.flattenTestData(test);
    this.showTestDialog = true;
  }
  
  downloadRegistrationDetailsByIndex(index: number) {
    const details = this.allRegistrationDetails[index] || [];
    if (details.length === 0) {
      this.messageService.add({ severity: 'warn', summary: 'No Data', detail: 'No registration details available for download.' });
      return;
    }
    
    const csvData = this.convertToCSV(details);
    this.triggerDownload(csvData, `registration-details-${index + 1}.csv`);
  }
  
  downloadDocumentationDetailsByIndex(index: number) {
    const form = this.documentationForms[index];
    if (!form) return;

    const details = this.allDocumentationDetails[index] || [];
    if (details.length === 0) {
      this.fetchCandidateDetails('documentation', form.formId, index, () => {
        const d = this.allDocumentationDetails[index] || [];
        if (d.length > 0) {
          this.triggerDownload(this.convertToCSV(d), `documentation-details-${index + 1}.csv`);
        } else {
          this.messageService.add({ severity: 'warn', summary: 'No Data', detail: 'No documentation details available for download.' });
        }
      });
      return;
    }
    this.triggerDownload(this.convertToCSV(details), `documentation-details-${index + 1}.csv`);
  }

  downloadFeedbackDetailsByIndex(groupIndex: number) {
    const group = this.groupedFeedbackForms[groupIndex];
    if (!group) return;
    const formId = group.panelMembers?.[0]?.formId ?? group.formId;
    if (!formId) return;
    const feedbackIndex = this.feedbackForms.findIndex((f: any) => f.formId === formId);
    if (feedbackIndex === -1) return;

    const details = this.allFeedbackDetails[feedbackIndex] || [];
    if (details.length === 0) {
      this.fetchCandidateDetails('feedback', formId, feedbackIndex, () => {
        const d = this.allFeedbackDetails[feedbackIndex] || [];
        if (d.length > 0) {
          this.triggerDownload(this.convertToCSV(d), `feedback-details-${groupIndex + 1}.csv`);
        } else {
          this.messageService.add({ severity: 'warn', summary: 'No Data', detail: 'No feedback details available for download.' });
        }
      });
      return;
    }
    this.triggerDownload(this.convertToCSV(details), `feedback-details-${groupIndex + 1}.csv`);
  }
  
  downloadTestDetailsByIndex(index: number) {
    const test = this.testDetailsList[index];
    if (!test) {
      this.messageService.add({ severity: 'warn', summary: 'No Data', detail: 'No test details available to download.' });
      return;
    }
    
    const testDetailsData = this.flattenTestData(test);
    const csvData = this.convertToCSV(testDetailsData);
    this.triggerDownload(csvData, `test-details-${index + 1}.csv`);
  }
  
  downloadAllRegistrationDetails() {
    if (this.registrationForms.length === 0) {
      this.messageService.add({ severity: 'warn', summary: 'No Data', detail: 'No registration details available for download.' });
      return;
    }
    
    const allData = this.allRegistrationDetails.flat();
    if (allData.length === 0) {
      this.messageService.add({ severity: 'warn', summary: 'No Data', detail: 'No registration details loaded for download.' });
      return;
    }
    
    const csvData = this.convertToCSV(allData);
    this.triggerDownload(csvData, `all-registration-details.csv`);
  }
  
  downloadAllDocumentationDetails() {
    if (this.documentationForms.length === 0) {
      this.messageService.add({ severity: 'warn', summary: 'No Data', detail: 'No documentation details available for download.' });
      return;
    }
    
    const allData = this.allDocumentationDetails.flat();
    if (allData.length === 0) {
      this.messageService.add({ severity: 'warn', summary: 'No Data', detail: 'No documentation details loaded for download.' });
      return;
    }
    
    const csvData = this.convertToCSV(allData);
    this.triggerDownload(csvData, `all-documentation-details.csv`);
  }
  
  downloadAllFeedbackDetails() {
    if (this.feedbackForms.length === 0) {
      this.messageService.add({ severity: 'warn', summary: 'No Data', detail: 'No feedback details available for download.' });
      return;
    }
    
    const allData = this.allFeedbackDetails.flat();
    if (allData.length === 0) {
      this.messageService.add({ severity: 'warn', summary: 'No Data', detail: 'No feedback details loaded for download.' });
      return;
    }
    
    const csvData = this.convertToCSV(allData);
    this.triggerDownload(csvData, `all-feedback-details.csv`);
  }
  
  downloadAllTestDetails() {
    if (this.testDetailsList.length === 0) {
      this.messageService.add({ severity: 'warn', summary: 'No Data', detail: 'No test details available for download.' });
      return;
    }
    
    const allTestData = this.testDetailsList.map(test => this.flattenTestData(test)).flat();
    if (allTestData.length === 0) {
      this.messageService.add({ severity: 'warn', summary: 'No Data', detail: 'No test details loaded for download.' });
      return;
    }
    
    const csvData = this.convertToCSV(allTestData);
    this.triggerDownload(csvData, `all-test-details.csv`);
  }
  
  downloadAttachmentsByIndex(formType: 'registration' | 'documentation', index: number) {
    const forms = formType === 'registration' ? this.registrationForms : this.documentationForms;
    const form = forms[index];
    
    if (!form) return;
  
    this.jobService.downloadCandidateAttachments(this.eventId, formType, form.formId).subscribe(
      (response: HttpResponse<Blob>) => {
        if (response.body) {
          const blob = new Blob([response.body], { type: 'application/zip' });
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = `${formType}-attachments-${index + 1}.zip`;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
        }
      },
      (error) => {
        // this.messageService.add({ severity: 'error', summary: 'Download Failed', detail: `Unable to download ${formType} attachments.` });
      }
    );
  }  
  
  async processData(formDetails: any, candidateDetails: any): Promise<any[]> {
    let formattedData: any[] = [];
    const hasFormStructure = formDetails && Object.keys(formDetails).length > 0;
    if (!hasFormStructure && candidateDetails) {
      return this.groupFlatCandidateFields(candidateDetails);
    }
    if (!formDetails || !candidateDetails) {
      return [{ section: "No Data Found", label: "", value: "-" }];
    }
    await this.fieldLookupService.loadLookupData(this.eventId, formDetails);

    Object.entries(formDetails).forEach(([section, fields]: [string, any]) => {
      let sectionData: any[] = [];
  
      fields.forEach((field: any) => {
        let fieldValue = candidateDetails[field.field_name] ?? "-";
  
        if (field.field_type === 'Multi-file' && Array.isArray(fieldValue) && fieldValue.length > 0) {
          const fileList = fieldValue.map((url: string) => {
            const fileName = this.extractFileName(url);
            const fileType = this.getFileType(fileName);
            return {
              fileName,
              fileType,
              url,
              size: this.getFileSize(url)
            };
          });
          
          sectionData.push({
            section: section,
            label: field.field_label,
            value: fieldValue,
            isMultiFile: true,
            fileList: fileList
          });
        } else if (typeof fieldValue === 'string' && this.isUrl(fieldValue)) {
          sectionData.push({
            section: section,
            label: field.field_label,
            value: fieldValue,
            isUrl: true,
            url: fieldValue
          });
        } else if (fieldValue !== "-" && fieldValue !== null && fieldValue !== "") {
          fieldValue = this.getFieldValueLabel(fieldValue, field.field_options);          
          if (fieldValue === candidateDetails[field.field_name] && this.fieldLookupService.isFieldSupported(field.field_name)) {
            fieldValue = this.fieldLookupService.getLookupValue(field.field_name, fieldValue, this.eventId);
          }
          sectionData.push({
            section: section,
            label: field.field_label,
            value: fieldValue
          });
        } else {
          sectionData.push({
            section: section,
            label: field.field_label,
            value: fieldValue
          });
        }
      });
  
      if (sectionData.length > 0) {
        formattedData = [...formattedData, ...sectionData];
      }
    });
  
    return formattedData.length ? formattedData : [{ section: "No Data Found", label: "", value: "-" }];
  }
  groupFlatCandidateFields(candidateDetails: any): any[] {
    const readable = Object.entries(candidateDetails)
      .filter(([key, value]) => key !== 'id' && key !== 'candidate_uuid' && value !== null && value !== '')
      .map(([key, value]) => {
        if ((key === 'created_at' || key === 'updated_at') && typeof value === 'string') {
          value = this.formatDate(value);
        }
        return {
          section: 'Feedback Summary',
          label: this.formatFieldName(key),
          value: value
        };
      });
    return readable.length ? readable : [{ section: "No Data Found", label: "", value: "-" }];
  }
  isUrl(value: string): boolean {
    const urlPattern = /^(https?:\/\/[^\s]+)/i;
    return urlPattern.test(value);
  }

  extractFileName(url: string): string {
    try {
      const urlObj = new URL(url);
      const pathname = urlObj.pathname;
      const fileName = pathname.split('/').pop() || 'Unknown File';
      return decodeURIComponent(fileName);
    } catch (error) {
      console.error('Error extracting file name from URL:', error);
      return 'Unknown File';
    }
  }

  getFileType(fileName: string): string {
    const extension = fileName.split('.').pop()?.toLowerCase() || '';
    const typeMap: { [key: string]: string } = {
      'pdf': 'PDF',
      'doc': 'Document',
      'docx': 'Document',
    };
    return typeMap[extension] || 'File';
  }

  getFileSize(url: string): string {
    return 'Unknown Size';
  }

  getFileIcon(fileType: string): string {
    const iconMap: { [key: string]: string } = {
      'PDF': 'pi-file-pdf',
      'Document': 'pi-file-word',
      'File': 'pi-file'
    };
    return iconMap[fileType] || 'pi-file';
  }

  viewFile(url: string): void {
    if (url) {
      window.open(url, '_blank');
    }
  }

  downloadFile(url: string, fileName: string): void {
    if (url) {
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName;
      link.target = '_blank';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
  
  
  formatFieldName(key: string): string {
    return key.replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase());
  }
  
  isFileField(fieldName: string): boolean {
    const fileFields = ["resume_cv", "cover_letter"];
    return fileFields.includes(fieldName);
  }
  

  
  loadAllDocumentFeedbackDetails() {
    if (!this.registrationDetails.length) {
      this.fetchCandidateDetails('registration');
    }
    if (!this.documentationDetails.length) {
      this.fetchCandidateDetails('documentation');
    }
    if (!this.feedbackDetailsData.length) {
      this.fetchCandidateDetails('feedback');
    }
  }
  
  

  flattenTestData(test: any): any[] {
    if (!test) return [];
  
    const readable = [];
    readable.push({ section: 'Test Summary', label: 'Test Name', value: test.contest_test_name });
    readable.push({ section: 'Test Summary', label: 'Stage', value: test.stage_name });
    readable.push({ section: 'Test Summary', label: 'Course Name', value: test.contest_name });
    readable.push({ section: 'Test Summary', label: 'Duration (mins)', value: test.contest_test_duration });
    const score = test.scores?.[0];
    if (score) {
      readable.push({ section: 'Score', label: 'Submitted At', value: this.formatDate(score.submit_time) });
      readable.push({ section: 'Score', label: 'Marks', value: `${score.mark}/${score.total_mark}` });
      readable.push({ section: 'Score', label: 'Attempts', value: score.attempt });
    }
    return readable;
  }

      
  

closeDialog() {
  this.displayDetails = false; 
  this.showRegistrationDialog = false;
  this.showDocumentationDialog = false;
  this.registrationDetails = [];
  this.documentationDetails = [];
  this.showRegistrationMenu = false;
  this.showDocumentationMenu = false;
  
  setTimeout(() => {
    this.cdr.detectChanges();
  }, 100);

}
closeDocumentationDialog() {
  this.showDocumentationDialog = false;
  this.documentationDetails = [];
  this.cdr.detectChanges();
}

getGroupedSections(data: any[]): { name: string, fields: any[] }[] {
  const grouped: { [key: string]: any[] } = {};

  data.forEach(item => {
    const section = item.section || 'Other';
    if (!grouped[section]) {
      grouped[section] = [];
    }
    grouped[section].push(item);
  });

  return Object.keys(grouped).map(section => ({
    name: section,
    fields: grouped[section]
  }));
}



filterValidData(formData: any): any {
  if (!formData) return [];

  const filteredData = Object.keys(formData)
    .filter(key => formData[key] !== null && formData[key] !== '') 
    .map(key => ({
      label: this.formatFieldName(key),
      value: this.isFileField(key) 
        ? `<a href="${formData[key]}" target="_blank">View File</a>` 
        : formData[key]
    }));

  return filteredData.length ? filteredData : [{ label: "No Data Found", value: "-" }];
}

convertToCSV(data: { label: string; value: string; isMultiFile?: boolean }[]): string {
  const header = 'Field,Value\n';
  const rows = data
    .filter(row => !row.isMultiFile && !this.containsLink(row.value))
    .map(row => `"${row.label}","${row.value}"`)
    .join('\n');

  return header + rows;
}
containsLink(value: string): boolean {
  if (typeof value !== 'string') return false;
  const urlPattern = /^https?:\/\/\S+/i;
  const anchorTagPattern = /<a\s+[^>]*href="[^"]*"[^>]*>(.*?)<\/a>/i;
  return urlPattern.test(value) || anchorTagPattern.test(value);
}


triggerDownload(content: string, fileName: string) {
  const blob = new Blob([content], { type: 'text/csv' });
  const url = window.URL.createObjectURL(blob);
  
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);

  window.URL.revokeObjectURL(url);
}

  fetchCandidateInfo() {
    if (!this.selectedUser?.id || !this.eventId) {
      return;
    }
    this.isLoadingResume = true;
    this.jobService.getCandidateInfo(this.selectedUser.id, this.eventId, true).subscribe(
      (response: any) => {
        if (!response?.body?.candidate_details) {
          console.warn("Candidate details not found in response");
          return;
        }

      const candidateData = response.body.candidate_details;
      const formDetails = response.body.form_details;
      const stageDetails = response.body?.stages;
      const roleScores = response.body?.role_scores;
      
      if (stageDetails) {
        this.selectedUser = {
          ...this.selectedUser,
          stage: {
            current_stage: stageDetails.current_stage ?? 0,
            total_stage: stageDetails.total_stage ?? 1
          }
        };
      }
      
      if (roleScores) {
        this.roleScores = roleScores;
      } else {
        this.roleScores = [];
      }
      
      if (this.displayInsights) {
        this.isLoadingDetails = false;
      }
      const currentCity = candidateData?.current_city ?? '-';
      const dateOfBirth = candidateData?.date_of_birth ?? '-';
      const genderOptions = this.findFieldOption(formDetails, 'gender');
      const genderLabel = candidateData.gender && genderOptions?.length 
        ? (genderOptions.find((opt: any) => opt.value === candidateData.gender)?.label || candidateData.gender)
        : (candidateData.gender ?? '-');
      this.personalInfo = [
        { field: "Gender", value: genderLabel },
        { field: "Date of Birth", value: dateOfBirth }, 
        { field: "Current Address", value: currentCity }, 
      ];
      this.processEducationData(candidateData,formDetails);
      this.educationQualification = [
        { field: "Degree", value: candidateData?.degreeDetails?.[0]?.degree ?? '-' },
        { field: "Department", value: candidateData?.degreeDetails?.[0]?.specialization ?? '-' },
        { field: "Batch", value: candidateData?.graduationYear ?? '-' },
      ];

        this.signedProfileUrl = candidateData?.profilePic;

        if (candidateData && candidateData.resume_cv) {
          const resumeUrl = candidateData.resume_cv;
          this.pdfSrc = resumeUrl;
          this.resumeFileType = this.getFileTypeFromUrl(resumeUrl);
          this.isLoadingResume = false;
        } else {
          this.pdfSrc = null;
          this.resumeFileType = 'pdf';
          this.isLoadingResume = false;
        }

      this.cdr.detectChanges();
    },
    (error) => {
      this.messageService.add({ 
        severity: 'warn', 
        summary: 'No Event Found', 
        detail: 'There are no events available at this time.' 
      });
      const candidateData = this.selectedUser || {};
      this.personalInfo = [
        { field: "Gender", value: candidateData.gender ?? '-' },
        { field: "Date of Birth", value: candidateData.date_of_birth ?? '-' },
        { field: "Current Address", value: candidateData.current_city ?? '-' },
      ];
      if (this.selectedUser) {
        this.processEducationData(this.selectedUser,null);
      }
      this.educationQualification = [
        { field: "Degree", value: candidateData?.degreeDetails?.[0]?.degree ?? '-' },
        { field: "Department", value: candidateData?.degreeDetails?.[0]?.specialization ?? '-' },
        { field: "Batch", value: candidateData?.graduationYear ?? '-' },
      ];
      this.signedProfileUrl = candidateData?.profilePic;
      
      // Clear loading state in case of error
      if (this.displayInsights) {
        this.isLoadingDetails = false;
      }
      
      this.roleScores = [];
      this.cdr.detectChanges();
    }
  );
}

toggleSection(section: string): void {
  switch(section) {
    case 'pg':
      this.pgExpanded = !this.pgExpanded;
      break;
    case 'ug':
      this.ugExpanded = !this.ugExpanded;
      break;
    case 'diploma':
      this.diplomaExpanded = !this.diplomaExpanded;
      break;
    case 'registration':
    case 'documentation':
    case 'feedback':
    case 'tests':
      this.expandedSection = this.expandedSection === section ? null : section;
      break;
  }
}

setFilter(filter: string): void {
  this.activeFilter = filter;
  // Auto-expand the section if filtering to a specific category
  if (filter !== 'all') {
    this.expandedSection = filter;
  }
}

getTotalCount(): number {
  return this.registrationForms.length + 
         this.documentationForms.length + 
         this.feedbackForms.length + 
         this.testDetailsList.length;
}
private processEducationData(candidateData: any,formDetails:any): void {
  this.processPGDetails(candidateData,formDetails);  
  this.processUGDetails(candidateData,formDetails);  
  this.processDiplomaDetails(candidateData,formDetails);
}
findFieldOption(formDetails: any, fieldName: string): any[] {
  for (const sectionName in formDetails) {
    const section = formDetails[sectionName];
    const found = section.find((f: any) => f.field_name === fieldName);
    if (found) return found.field_options || null;
  }
  return [];
}

extractBatchValue(startDate?: string, endDate?: string): string {
  const startYear = startDate ? new Date(startDate).getFullYear() : '';
  const endYear = endDate ? new Date(endDate).getFullYear() : '';
  if (startYear && endYear) return `${startYear}-${endYear}`;
  if (startYear) return `${startYear}-Present`;
  if (endYear) return `${endYear}`;
  return '-';
}
getLabelFromOptions(options: any[], value: any): string {
  if (!options || !Array.isArray(options)) return value || '-';
  const found = options.find(opt => opt.value == value);
  return found ? found.label : value || '-';
}

  getFieldValueLabel(fieldValue: any, fieldOptions: any[]): any {
    if (fieldValue === null || fieldValue === undefined || fieldValue === '') return '-';
    if (!fieldOptions?.length) return fieldValue;
    
    if (Array.isArray(fieldValue)) {
      if (fieldValue.length === 0) return '-';
      return fieldValue.map(val => {
        const option = fieldOptions.find(opt => opt.value == val);
        return option ? option.label : val;
      }).join(', ');
    }
    
    const option = fieldOptions.find(opt => opt.value == fieldValue);
    return option ? option.label : fieldValue;
  }



private processPGDetails(candidateData: any, formDetails: any): void {
  let hasAnyPGData = false;
  this.pgEducationFields = [];
  const pgDegreeNameOptions = this.findFieldOption(formDetails, "pg_degree");
  const pgDegreeOptions = this.findFieldOption(formDetails, "pg_degree_type");
  const pgSpecializationOptions = this.findFieldOption(formDetails, "pg_specialization");

  const pgDegreeNameValue = candidateData?.pg_degree || '-';
  const pgDegreeNameLabel = this.getLabelFromOptions(pgDegreeNameOptions, pgDegreeNameValue);
  this.pgEducationFields.push({ field: "Degree", value: pgDegreeNameLabel });
  if (pgDegreeNameValue && pgDegreeNameValue !== '-') hasAnyPGData = true;

  const pgDegreeValue = candidateData?.pg_degree_type || '-';
  const pgDegreeLabel = this.getLabelFromOptions(pgDegreeOptions, pgDegreeValue);
  this.pgEducationFields.push({ field: "Degree Type", value: pgDegreeLabel });
  if (pgDegreeValue && pgDegreeValue !== '-') hasAnyPGData = true;
  const pgSpecializationValue = candidateData?.pg_specialization || '-';
  const pgSpecializationLabel = this.getLabelFromOptions(pgSpecializationOptions, pgSpecializationValue);
  this.pgEducationFields.push({ field: "Specialization", value: pgSpecializationLabel });
  if (pgSpecializationValue && pgSpecializationValue !== '-') hasAnyPGData = true;

  const batchValue = this.extractBatchValue(candidateData?.pg_start_date, candidateData?.pg_end_date); // CHANGE
  this.pgEducationFields.push({ field: "Batch", value: batchValue });
  if (batchValue !== '-') hasAnyPGData = true;

  let percentageValue = '-';
  if (candidateData?.pg_percentage) {
    percentageValue = `${candidateData.pg_percentage}%`;
    hasAnyPGData = true;
  } else if (candidateData?.pg_cgpa) {
    percentageValue = `${candidateData.pg_cgpa} CGPA`;
    hasAnyPGData = true;
  }
  this.pgEducationFields.push({ field: "Percentage", value: percentageValue });

  const collegeValue = candidateData?.pg_college_name || '-'; // CHANGE
  this.pgEducationFields.push({ field: "College", value: collegeValue });
  if (collegeValue && collegeValue !== '-') hasAnyPGData = true;

  this.hasPGDetails = hasAnyPGData;
}


private processUGDetails(candidateData: any, formDetails: any): void {
  let hasAnyUGData = false;
  this.ugEducationFields = [];

  const ugDegreeNameOptions = this.findFieldOption(formDetails, "ug_degree");
  const ugDegreeOptions = this.findFieldOption(formDetails, "ug_degree_type");
  const ugSpecializationOptions = this.findFieldOption(formDetails, "ug_specialization");

  const ugDegreeNameValue = candidateData?.ug_degree || '-';
  const ugDegreeNameLabel = this.getLabelFromOptions(ugDegreeNameOptions, ugDegreeNameValue);
  this.ugEducationFields.push({ field: "Degree", value: ugDegreeNameLabel });
  if (ugDegreeNameValue && ugDegreeNameValue !== '-') hasAnyUGData = true;

  const ugDegreeValue = candidateData?.ug_degree_type || '-';
  const ugDegreeLabel = this.getLabelFromOptions(ugDegreeOptions, ugDegreeValue);
  this.ugEducationFields.push({ field: "Degree Type", value: ugDegreeLabel });
  if (ugDegreeValue && ugDegreeValue !== '-') hasAnyUGData = true;

  const ugSpecializationValue = candidateData?.ug_specialization || '-';
  const ugSpecializationLabel = this.getLabelFromOptions(ugSpecializationOptions, ugSpecializationValue);
  this.ugEducationFields.push({ field: "Specialization", value: ugSpecializationLabel });
  if (ugSpecializationValue && ugSpecializationValue !== '-') hasAnyUGData = true;

  const batchValue = this.extractBatchValue(candidateData?.ug_start_date, candidateData?.ug_end_date);
  this.ugEducationFields.push({ field: "Batch", value: batchValue });
  if (batchValue !== '-') hasAnyUGData = true;

  let percentageValue = '-';
  if (candidateData?.ug_percentage) {
    percentageValue = `${candidateData.ug_percentage}%`;
    hasAnyUGData = true;
  } else if (candidateData?.ug_cgpa) {
    percentageValue = `${candidateData.ug_cgpa} CGPA`;
    hasAnyUGData = true;
  }
  this.ugEducationFields.push({ field: "Percentage", value: percentageValue });

  const collegeValue = candidateData?.ug_college_name || '-';
  this.ugEducationFields.push({ field: "College", value: collegeValue });
  if (collegeValue && collegeValue !== '-') hasAnyUGData = true;

  this.hasUGDetails = hasAnyUGData;
}

private processDiplomaDetails(candidateData: any, formDetails: any): void {
  let hasAnyDiplomaData = false;
  this.diplomaEducationFields = [];

  const diplomaDegreeNameOptions = this.findFieldOption(formDetails, "diploma_degree");
  const diplomaDegreeOptions = this.findFieldOption(formDetails, "diploma_degree_type");
  const diplomaSpecializationOptions = this.findFieldOption(formDetails, "diploma_specialization");

  const diplomaDegreeNameValue = candidateData?.diploma_degree || '-';
  const diplomaDegreeNameLabel = this.getLabelFromOptions(diplomaDegreeNameOptions, diplomaDegreeNameValue);
  this.diplomaEducationFields.push({ field: "Degree", value: diplomaDegreeNameLabel });
  if (diplomaDegreeNameValue && diplomaDegreeNameValue !== '-') hasAnyDiplomaData = true;

  const diplomaDegreeValue = candidateData?.diploma_degree_type || '-';
  const diplomaDegreeLabel = this.getLabelFromOptions(diplomaDegreeOptions, diplomaDegreeValue);
  this.diplomaEducationFields.push({ field: "Degree Type", value: diplomaDegreeLabel });
  if (diplomaDegreeValue && diplomaDegreeValue !== '-') hasAnyDiplomaData = true;

  const diplomaSpecializationValue = candidateData?.diploma_specialization || '-';
  const diplomaSpecializationLabel = this.getLabelFromOptions(diplomaSpecializationOptions, diplomaSpecializationValue);
  this.diplomaEducationFields.push({ field: "Specialization", value: diplomaSpecializationLabel });
  if (diplomaSpecializationValue && diplomaSpecializationValue !== '-') hasAnyDiplomaData = true;

  const batchValue = this.extractBatchValue(candidateData?.diploma_start_date, candidateData?.diploma_end_date);
  this.diplomaEducationFields.push({ field: "Batch", value: batchValue });
  if (batchValue !== '-') hasAnyDiplomaData = true;

  let percentageValue = '-';
  if (candidateData?.diploma_percentage) {
    percentageValue = `${candidateData.diploma_percentage}%`;
    hasAnyDiplomaData = true;
  } else if (candidateData?.diploma_cgpa) {
    percentageValue = `${candidateData.diploma_cgpa} CGPA`;
    hasAnyDiplomaData = true;
  }
  this.diplomaEducationFields.push({ field: "Percentage", value: percentageValue });

  const collegeValue = candidateData?.diploma_college_name || '-';
  this.diplomaEducationFields.push({ field: "College", value: collegeValue });
  if (collegeValue && collegeValue !== '-') hasAnyDiplomaData = true;

  this.hasDiplomaDetails = hasAnyDiplomaData;
}

  // Activity Timeline Helper Methods
  getActivityIconClass(action: string): string {
    switch (action) {
      case 'Move Stage':
        return 'icon-stage-move';
      case 'Send Mail':
        return 'icon-email';
      case 'Registration':
        return 'icon-registration';
      case 'Status Change':
        return 'icon-status-change';
      default:
        return 'icon-default';
    }
  }

  getActivityIcon(action: string): string {
    switch (action) {
      case 'Move Stage':
        return 'pi pi-sync';
      case 'Send Mail':
        return 'pi pi-envelope';
      case 'Registration':
        return 'pi pi-check-circle';
      case 'Status Change':
        return 'pi pi-arrow-circle-right';
      default:
        return 'pi pi-user';
    }
  }

  getActivityTitle(action: string): string {
    switch (action) {
      case 'Move Stage':
        return 'Stage Moved';
      case 'Send Mail':
        return 'Email Sent';
      case 'Registration':
        return 'Registration Completed';
      case 'Status Change':
        return 'Status Updated';
      default:
        return action || 'Activity';
    }
  }

  // Remove duplicate forms based on formId and submittedDate
  private removeDuplicateForms<T extends { formId: number; submittedDate: string }>(forms: T[]): T[] {
    const seen = new Set<string>();
    return forms.filter(form => {
      const key = `${form.formId}-${form.submittedDate}`;
      if (seen.has(key)) {
        return false;
      }
      seen.add(key);
      return true;
    });
  }

  // Copy text to clipboard with user feedback
  copyToClipboard(text: string, label: string): void {
    if (!text) return;
    
    // Try modern clipboard API first
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(text).then(() => {
        this.messageService.add({
          severity: 'success',
          summary: 'Copied!',
          detail: `${label} copied to clipboard`,
          life: 2000
        });
      }).catch((err) => {
        console.error('Clipboard API failed:', err);
        this.fallbackCopyToClipboard(text, label);
      });
    } else {
      // Fallback for older browsers or non-secure contexts
      this.fallbackCopyToClipboard(text, label);
    }
  }

  // Fallback copy method using document.execCommand
  private fallbackCopyToClipboard(text: string, label: string): void {
    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.style.position = 'fixed';
    textArea.style.left = '-999999px';
    textArea.style.top = '-999999px';
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    
    try {
      const successful = document.execCommand('copy');
      if (successful) {
        this.messageService.add({
          severity: 'success',
          summary: 'Copied!',
          detail: `${label} copied to clipboard`,
          life: 2000
        });
      } else {
        this.messageService.add({
          severity: 'warn',
          summary: 'Copy Failed',
          detail: 'Please copy manually: ' + text,
          life: 3000
        });
      }
    } catch (err) {
      console.error('Fallback copy failed:', err);
      this.messageService.add({
        severity: 'error',
        summary: 'Copy Failed',
        detail: 'Please copy manually: ' + text,
        life: 3000
      });
    } finally {
      document.body.removeChild(textArea);
    }
  }
  hasValidPhoto(candidate: any): boolean {
    return candidate?.photo && 
           candidate.photo.trim() !== '' && 
           candidate.photo !== 'null' && 
           candidate.photo !== null;
  }

  onImageError(event: any, candidate: any): void {
    event.target.style.display = 'none';
    const initialsElement = event.target.nextElementSibling;
    if (initialsElement) {
      initialsElement.style.display = 'flex';
    }  
    candidate._photoError = true;
  }

  onImageLoad(event: any): void {
    event.target.style.display = 'block';
    const initialsElement = event.target.nextElementSibling;
    if (initialsElement) {
      initialsElement.style.display = 'none';
    }
  }

  getInitials(fullName: string): string {
    if (!fullName) return 'UN';
    
    const names = fullName.trim().split(' ');
    if (names.length === 1) {
      return names[0].charAt(0).toUpperCase();
    }
    
    const firstInitial = names[0].charAt(0).toUpperCase();
    const lastInitial = names[names.length - 1].charAt(0).toUpperCase();
    return firstInitial + lastInitial;
  }

  getAvatarColor(name: string): string {
    const colors = [
      '#FF6B35', '#4ECDC4', '#45B7D1', '#96CEB4', '#FECA57', 
      '#FF9FF3', '#54A0FF', '#5F27CD', '#00D2D3', '#FF9F43',
      '#EE5A24', '#009432', '#0652DD', '#9980FA', '#833471',
      '#F79F1F', '#A3CB38', '#1289A7', '#D63031', '#74B9FF'
    ];
    
    if (!name) return colors[0];
    
    let hash = 0;
    for (let i = 0; i < name.length; i++) {
      hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }
    
    return colors[Math.abs(hash) % colors.length];
  }

  getFullName(): string {
    const fullName = this.selectedUser?.name?.trim();
    
    if (!fullName && this.selectedUser?.email) {
      return this.selectedUser.email.split('@')[0];
    }
    
    return fullName || 'Unknown';
  }


  getOptimizationStats(): any {
    const sampleFormDetails = {
      'Personal Information': [
        { field_name: 'preferred_role', field_label: 'Preferred Role' },
        { field_name: 'ug_college_name', field_label: 'UG College' }
      ],
      'Education': [
        { field_name: 'class10_board_name', field_label: 'Class 10 Board' }
      ]
    };
    
    return this.fieldLookupService.getOptimizationStats(this.eventId, sampleFormDetails);
  }

  getSharedCacheStatus(): any {
    const sharedService = this.globalService.getSharedService();
    return {
      isCommonDataLoaded: sharedService.isCommonLookupDataLoaded(),
      commonData: sharedService.getCommonLookupData(),
      eventId: this.eventId
    };
  }

  getAlignmentClass(alignmentCategory: string): string {
    if (!alignmentCategory) return 'alignment-neutral';
    
    switch (alignmentCategory.toLowerCase()) {
      case 'high':
        return 'alignment-high';
      case 'medium':
        return 'alignment-medium';
      case 'low':
        return 'alignment-low';
      case 'insufficient data':
        return 'alignment-insufficient';
      default:
        return 'alignment-neutral';
    }
  }

  hasAnyEducationalQualifications(): boolean {
    return this.hasPGDetails || this.hasUGDetails || this.hasDiplomaDetails;
  }

  private loadCompanyMetadata(): void {
    try {
      const raw = localStorage.getItem('company-details');
      const parsed = raw ? JSON.parse(raw) : null;
      if (parsed) {
        this.companyMetadata = parsed.company_metadata || parsed.company_details || parsed;
      } else {
        this.companyMetadata = {};
      }
    } catch (_e) {
      this.companyMetadata = {};
      }
  }

  isSkillScoreEnabled(): boolean {
    if (!this.companyMetadata?.company_config) {
      return false;
    }
    return this.companyMetadata.company_config.skill_scores ?? false;
  }

  // Helper methods for new UI template
  getPersonalInfoValue(fieldName: string): string {
    const field = this.personalInfo.find((info: any) =>
      info.field.toLowerCase() === fieldName.toLowerCase()
    );
    return field?.value || '-';
  }

  getUGFieldValue(fieldName: string): string {
    const field = this.ugEducationFields.find((f: any) =>
      f.field.toLowerCase().includes(fieldName.toLowerCase())
    );
    return field?.value || '';
  }

  getPGFieldValue(fieldName: string): string {
    const field = this.pgEducationFields.find((f: any) =>
      f.field.toLowerCase().includes(fieldName.toLowerCase())
    );
    return field?.value || '';
  }

  getDiplomaFieldValue(fieldName: string): string {
    const field = this.diplomaEducationFields.find((f: any) =>
      f.field.toLowerCase().includes(fieldName.toLowerCase())
    );
    return field?.value || '';
  }

  groupFeedbackByStage() {
    this.groupedFeedbackForms = [];
    const grouped = new Map<string, any>();

    this.feedbackForms.forEach((form: any) => {
      const interviewKey = form.interviewUuid || form.formId?.toString() || '';
      const key = [form.stageUuid || form.stageName || 'Other', interviewKey].filter(Boolean).join('|') || 'Other';

      if (!grouped.has(key)) {
        grouped.set(key, {
          stageName: form.stageName,
          stageUuid: form.stageUuid,
          interviewUuid: form.interviewUuid,
          submittedDate: form.submittedDate,
          panelMembers: []
        });
      }

      const group = grouped.get(key);
      group.panelMembers.push({
        formId: form.formId,
        submittedBy: form.submittedBy,
        submittedById: form.submittedById,
        submittedDate: form.submittedDate,
        formName: form.formName
      });
    });

    this.groupedFeedbackForms = Array.from(grouped.values()).map((group: any) => {
      const stageName = group.stageName || 'Feedback';
      if (group.panelMembers && group.panelMembers.length === 1) {
        const member = group.panelMembers[0];
        return {
          ...group,
          stageName,
          formId: member.formId,
          submittedBy: member.submittedBy,
          submittedById: member.submittedById,
          panelMembers: null
        };
      }
      return { ...group, stageName };
    });
  }
}
